import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, Optional, APP_INITIALIZER, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import * as i3 from 'angular-svg-icon';
import { Subject, EMPTY } from 'rxjs';
import { tap, catchError, take } from 'rxjs/operators';

class AngularSvgIconPreloaderConfig {
    constructor() {
        this.configUrl = './assets/icons.json';
    }
}

class AngularSvgIconPreloaderService {
    constructor(_http, config, _iconRegistry) {
        this._http = _http;
        this._iconRegistry = _iconRegistry;
        this.configUrl = './assets/icons.json';
        this.iconsFileData = { customIcons: [], iconImageFiles: [] };
        this.configSubject = new Subject();
        if (config && config.configUrl) {
            this.configUrl = config.configUrl;
        }
    }
    loadConfig() {
        return this._http
            .get(this.configUrl)
            .pipe(tap((configData) => {
            this.iconsFileData = configData;
            this.loadIcons();
        }), catchError((err) => {
            console.error('An error occurred loading the icons:\n', err, '\nNo icons will be loaded.');
            this.iconsFileData = {
                customIcons: [],
                iconImageFiles: [],
            };
            this.loadIcons();
            return EMPTY;
        }));
    }
    loadIcons() {
        this.iconsFileData.iconImageFiles.forEach((i) => {
            const iconObs = this._iconRegistry.loadSvg(i.iconPath, i.iconName);
            if (iconObs) {
                iconObs.pipe(take(1)).subscribe();
            }
        });
        this.iconsFileData.customIcons.forEach((i) => {
            this._iconRegistry.addSvg(i.iconName, i.iconData);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: AngularSvgIconPreloaderService, deps: [{ token: i1.HttpClient }, { token: AngularSvgIconPreloaderConfig, optional: true }, { token: i3.SvgIconRegistryService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: AngularSvgIconPreloaderService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: AngularSvgIconPreloaderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: AngularSvgIconPreloaderConfig, decorators: [{
                    type: Optional
                }] }, { type: i3.SvgIconRegistryService }]; } });

function initConfig(svgSvc) {
    return () => svgSvc.loadConfig();
}
class AngularSvgIconPreloaderModule {
    static forRoot(config) {
        return {
            ngModule: AngularSvgIconPreloaderModule,
            providers: [
                {
                    provide: AngularSvgIconPreloaderConfig,
                    useValue: config,
                },
                AngularSvgIconPreloaderService,
            ],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: AngularSvgIconPreloaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.3", ngImport: i0, type: AngularSvgIconPreloaderModule, imports: [CommonModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: AngularSvgIconPreloaderModule, providers: [
            AngularSvgIconPreloaderService,
            {
                provide: APP_INITIALIZER,
                useFactory: initConfig,
                deps: [AngularSvgIconPreloaderService],
                multi: true,
            },
        ], imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: AngularSvgIconPreloaderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    providers: [
                        AngularSvgIconPreloaderService,
                        {
                            provide: APP_INITIALIZER,
                            useFactory: initConfig,
                            deps: [AngularSvgIconPreloaderService],
                            multi: true,
                        },
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AngularSvgIconPreloaderModule, AngularSvgIconPreloaderService, initConfig };
